


export const rotateToMouse = (e, questionCard, bounds) => {
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    const leftX = mouseX - bounds.x;
    const topY = mouseY - bounds.y;
    const center = {
      x: leftX - bounds.width / 2,
      y: topY - bounds.height / 2
    }
    const distance = Math.sqrt(center.x**2 + center.y**2);
    
    questionCard.style.transform = `
      scale3d(1.03, 1.03, 1.03)
      rotate3d(
        ${center.y / 100},
        ${-center.x / 100},
        0,
        ${Math.log(distance)* 2}deg
      )
    `;
    
    questionCard.querySelector('.glow').style.backgroundImage = `
      radial-gradient(
        circle at
        ${center.x * 2 + bounds.width/2}px
        ${center.y * 2 + bounds.height/2}px,
        #ffffff22, #0000000c, #ffffff0f
      )
    `;
  }


  export function initQuestionCarsRotation() {
    const questionCards = document.querySelectorAll('.form-question-selection-style');
    for (let questionCard of questionCards) {
        let bounds;
        const rotateToMouseWrapper = (e) => {
            rotateToMouse(e, questionCard, bounds);
        };

        questionCard.addEventListener('mouseenter', () => {
            bounds = questionCard.getBoundingClientRect();
            document.addEventListener('mousemove', rotateToMouseWrapper);
        });

        questionCard.addEventListener('mouseleave', () => {
            document.removeEventListener('mousemove', rotateToMouseWrapper);
            questionCard.style.transform = '';
            questionCard.style.background = '';
        });

    }
  }